import { BehaviorSubject } from 'rxjs';
import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SpinnerService {
    private counter: number = 0;

    private readonly stateBehaviour = new BehaviorSubject(false);
    readonly state$ = this.stateBehaviour.asObservable();

    private readonly ignoredEndpoints: string[] = [];

    readonly status$ = signal(false);

    show(): void {
        this.stateBehaviour.next(true);
    }

    hide(): void {
        this.stateBehaviour.next(false);
    }

    inc(): void {
        this.stateBehaviour.next(true);
        this.counter++;
    }

    dec(): void {
        if (this.counter > 0) {
            this.counter--;
        }
        if (this.counter === 0) {
            this.stateBehaviour.next(false);
        }
    }

    ignoreEndpoint(endpoint: string): void {
        if (!this.isIgnoredEndpoint(endpoint)) {
            this.ignoredEndpoints.push(endpoint);
        }
    }

    isIgnoredEndpoint(endpoint: string): boolean {
        return this.ignoredEndpoints.includes(endpoint);
    }

    removeIgnoredEndpoint(endpoint: string): void {
        const index = this.ignoredEndpoints.indexOf(endpoint);
        if (index > -1) {
            this.ignoredEndpoints.splice(index, 1);
        }
    }
}
